import { React, useEffect, useState } from "react";
import "./SingleDesign.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  getDesignByPinId,
  deleteDesign,
  getDesignById,
} from "../../../services/designService";
import CircleLoading from "../../../components/misc/CircleLoading/CircleLoading";
import STATIC_ROUTES, { BASE_URL } from "../../../misc/Static_routes";
import { getFullDate } from "../../../misc/misc";
import {Button} from "@mui/material";
import { validateEmail } from "../../../utils/helpers";
import { addVote, checkDesignIsLiked } from "../../../services/likeService";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { selectUser } from "../../../app/features/usersSlice";
import userIcon from "../../../assets/images/userIcon.svg";
import calendarIcon from "../../../assets/images/calendarIcon.svg";
import leftArrow from "../../../assets/images/rightArrow.svg";
import rightArrow from "../../../assets/images/leftArrow.svg";
import checkIcon from "../../../assets/images/checkIcon.svg";
import downloadIcon from "../../../assets/images/downloadIcon.svg";
import thumbUpIcon from "../../../assets/images/thumbUpIcon.svg";
import thumbUpIconWhite from "../../../assets/images/thumbUpWhite.svg";
import SingleDesignTablet from "./tabletView/SingleDesignTablet";
import SingleDesignDesktop from "./desktopView/SingleDesignDesktop";
import ReactCountryFlag from "react-country-flag";
import { countryMap } from "../../../utils/constants";
import ShareButtonsMobile from "../../../components/Buttons/ShareButtonsMobile/ShareButtonsMobile";
import VoteBtn from "../../../components/Buttons/VoteBtn/VoteBtn";
import CancelDialog from "../../../components/CancelDialog/CancelDialog";

const errorToast = (message) => toast.error(`${message}`);
const warnToast = (message) => toast.warn(`${message}`);

const SingleDesign = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const deleteBtnText = t('delete');

  const user = useAppSelector(selectUser);
  const userName = user?.length > 0 ? user.name : "Anonymous";

  const [cookies, setCookie] = useCookies(["emailVoted"]);
  const [allDesigns, setAllDesigns] = useState({});
  const [design, setDesign] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState(
    cookies["emailVoted"] ? cookies["emailVoted"] : ""
  );
  const [emailValidation, setEmailValidation] = useState("");
  const [likes, setLikes] = useState(design.likes?.length);
  const [cityName, setCityName] = useState("");
  const shareUrl = `${process.env.REACT_APP_BASE_URL}/pin/${design.pin_id}/design/${design.id}`;
  const [currentDesignIndex, setCurrentDesignIndex] = useState();
  const [locationData, setLocationData] = useState({});
  const [voteBtnState, setVoteBtnState] = useState('untouched');
  const noTitle = `${locationData?.location} Design - ${currentDesignIndex}`;
  const [openCancelDialog, setOpenCancelDialog] = useState(false);

  useEffect(() => {
    setVoteBtnState('untouched');
    setIsLoading(true);
    let allDesignsData;
    const data = getDesignByPinId(params.pinID);
    data.then((values) => {
      const sortedDesigns = [...setSort(values.data)];
      setAllDesigns(sortedDesigns);
      setLocationData({
        country: values.country,
        city: values.cityName,
        location: values.pinName,
      });
      allDesignsData = [...setSort(values.data)];
      let findItem = false;
      sortedDesigns.map((item) => {
        if (item.id === params.designID) {
          setCityName(values.cityName);
          const getAgainDesign = getDesignById(params.pinID, item.id);
          getAgainDesign.then((value) => {
            setDesign(value.data);
            findCurrentDesIndex(value.data, sortedDesigns);
          });
          // setDesign(item);
          setLikes(item.likes.length);
          findItem = true;
        }
      });
      setIsLoading(false);
      if (!findItem) {
        navigate(STATIC_ROUTES.not_found);
      }
    });
  }, []);

  const setSort = (arr) => {
    const sortOrder = location?.state?.sortOrder;

    if (!sortOrder) {
      //sort by most recent if no sorting order
      return arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    }

    if (sortOrder === "mostRecent") {
      return arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    } else if (sortOrder === "mostVoted") {
      return arr.sort((a, b) => b?.likes?.length - a?.likes?.length)
    } else if (sortOrder === "leastVoted") {
      return arr.sort((a, b) => a?.likes?.length - b?.likes?.length)
    }
  }

  const findCurrentDesIndex = (currentD, allDes) => {
    let index = allDes.findIndex((des) => des.id === currentD.id) + 1;
    setCurrentDesignIndex(index);
  };

  const changeDesign = (direction) => {
    setVoteBtnState('untouched')
    allDesigns.map((item, index) => {
      if (item.id === design.id) {
        if (direction === "prev") {
          if (index - 1 >= 0) {
            const prevDesign = allDesigns[index - 1];
            setCurrentDesignIndex((prevIndex) => prevIndex - 1);
            // setDesign(prevDesign);
            navigate(`/pin/${prevDesign.pin_id}/design/${prevDesign.id}`);
            const getAgainDesign = getDesignById(params.pinID, prevDesign.id);
            getAgainDesign.then((value) => {
              setDesign(value.data);
            });
          }
        } else {
          if (index + 1 < allDesigns.length) {
            const nextDesign = allDesigns[index + 1];
            setCurrentDesignIndex((prevIndex) => prevIndex + 1);
            // setDesign(nextDesign);
            navigate(`/pin/${nextDesign.pin_id}/design/${nextDesign.id}`);
            const getAgainDesign = getDesignById(params.pinID, nextDesign.id);
            getAgainDesign.then((value) => {
              setDesign(value.data);
            });
          }
        }
      }
    });
  };

  const handleDownload = () => {
    const uri = design.image;
    const link = document.createElement("a");
    link.href = uri;
    link.download = "image.png"; // Set the desired filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function onChangeEmail(e) {
    if (!validateEmail(e.target.value)) {
      setEmailValidation("Invalid email");
    } else {
      setEmailValidation("");
    }

    setEmail(e.target.value);
  }

  async function onClickVote() {
    if (email === "") {
      warnToast(t('pleaseEnterEmail'));
    } else {
      const vote = {
        design_id: design.id,
        email,
      };
      const designIsLiked = await checkDesignIsLiked(vote);
      // if (designIsLiked) {
      //   errorToast("Empty fields are not allowed!");
      //   return;
      // }
      if (!designIsLiked) {
        await addVote(vote);
        setVoteBtnState('voted');
        setLikes((prev) => prev + 1);
        const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 1);
        setCookie("emailVoted", email, { expires: expirationDate });
      }
    }
  }

  async function vote() {
    if (cookies["emailVoted"]) {
      const vote = {
        design_id: design.id,
        email,
      };
      const designIsLiked = await checkDesignIsLiked(vote);
      if (!designIsLiked) {
        setLikes((prev) => prev + 1);
        await addVote(vote);
        setVoteBtnState('voted');
      }
    } else {
      setVoteBtnState('clicked');
    }
  }

  const onClickDeleteDesign = async () => {
    await deleteDesign({ id: design.id });
    navigate(`/${cityName}/${design.pin_id}`);
  };

  return (
    <>
      {isLoading ? (
        <p className="loading">
          <CircleLoading />
        </p>
      ) : (
        <div className="single-design-page">
          <div className="mobile_wrapper">
            <div className="pin_page_heading_mob">
              <div className="titles_wrapper_main">
                <div className="title_small">CoTown</div>
                <div className="title_large">
                  <span className="title_word_background_line_wrapper">
                    <span className="title_word_background_line"></span>
                    DESIGN
                  </span>
                  {" " + "SHOWCASE"}
                </div>
              </div>
              <div className="design_nav_buttons_mob">
                <div
                  className="back_btn_mob"
                  onClick={() => navigate(`/${cityName}/${design.pin_id}`)}
                >
                  &#60; Back to Gallery
                </div>
                <div className="design_change_mob">
                  <button
                    onClick={() => changeDesign("prev")}
                    className="design_back"
                  >
                    <img src={rightArrow} />
                  </button>
                  <span className="mx-5">
                    {" "}
                    {currentDesignIndex} of {allDesigns?.length}{" "}
                  </span>
                  <button
                    onClick={() => changeDesign("next")}
                    className="design_fore"
                  >
                    <img src={leftArrow} />
                  </button>
                </div>
              </div>
            </div>
            <div className="design_page_content_mob">
              <div className="design_description_mob">
                <div className="design_location_mob">
                  <p className="country_mob aligned_text">
                    <ReactCountryFlag
                      countryCode={countryMap.get(locationData?.country)}
                      svg
                      style={{ width: "32px", height: "20px" }}
                      title={locationData?.country}
                    />
                    {locationData?.country}
                  </p>
                  <p className="location_mob">
                    {locationData?.location + ", " + locationData?.city}
                  </p>
                </div>
                <div className="design_creation_mob">
                  <div className="user_name_mob">
                    <img src={userIcon} />
                    {userName}
                  </div>
                  <div className="creation_date_mob">
                    <img src={calendarIcon} />
                    {getFullDate(design.createdAt)}
                  </div>
                </div>
              </div>
              <img
                className="single_design_image_mob"
                src={design.image}
                alt="Thumbnail"
              />
              <div className="image_info_btns_mob">
                <div className="single_des_info_btns_left_col">
                <VoteBtn 
                  vote={vote} 
                  onClickVote={onClickVote} 
                  onChangeEmail={onChangeEmail}
                  email={email}
                  voteBtnState={voteBtnState}
                ></VoteBtn>
                  <div className="image_votes aligned_text">
                    <img src={checkIcon} alt="Votes Icon" /> {likes || 0} Votes
                  </div>
                </div>
                <div className="single_des_info_btns_right_col">
                  <ShareButtonsMobile facebookUrl={shareUrl}></ShareButtonsMobile> 
                  <button className="download_btn aligned_text" onClick={handleDownload}>
                    Download
                    <img style={{marginLeft: '10px'}} src={downloadIcon} alt="download" />
                  </button>
                </div>      
              </div>
              <div className="single_des_hor_line_mob"></div>
              <div>
                  <p className="single_des_title_label" style={{margin: '20px 0 0 0'}}>Title:</p>
                  <p className="single_des_title" style={{marginTop: 0}}>{design?.title || noTitle}</p>
                  {design?.comment && 
                   <>
                   <p className="single_des_comment_label" style={{margin: 0}}>Description:</p>
                   <p className="single_des_comment" style={{marginTop: 0}}>{design?.comment}</p>
                  </>
                  }
              </div>
              <div className="single_des_hor_line_mob"></div>

              <div style={{display: 'inline-block'}}>
                <button 
                  className="btn_rounded_border_animation" 
                  onClick={() => navigate(`/pin/${design.pin_id}/create-design`)}
                >
                  <span className="btn_rounded_border_animation_text">Make your own design</span>
                </button>
              </div>
              {user?.length > 0 && (
                  <Button
                    variant="contained"
                    color="error"
                    sx={{ marginTop: "20px" }}
                    onClick={() => setOpenCancelDialog(true)}
                  >
                    {deleteBtnText}
                  </Button>
              )}
            </div>
          </div>
          <CancelDialog
            openCancelDialog={openCancelDialog}
            setOpenCancelDialog={setOpenCancelDialog}
            dialogActionHandler={onClickDeleteDesign}
            cancelDialogTitle={'Do you really want to delete this design?'}
            cancelDialogSubtitle={'Deletion can not be restored'}
          ></CancelDialog>
          <div className="tablet_design">
            <SingleDesignTablet
              changeDesign={changeDesign}
              design={design}
              likes={likes}
              handleDownload={handleDownload}
              vote={vote}
              onClickDeleteDesign={() => setOpenCancelDialog(true)}
              shareUrl={shareUrl}
              userName={userName}
              leftArrow={leftArrow}
              rightArrow={rightArrow}
              userIcon={userIcon}
              calendarIcon={calendarIcon}
              user={user}
              thumbUpIcon={thumbUpIconWhite}
              downloadIcon={downloadIcon}
              currentIndex={currentDesignIndex}
              designsCount={allDesigns?.length}
              locationData={locationData}
              voteBtnState={voteBtnState}
              onClickVote={onClickVote}
              onChangeEmail={onChangeEmail} 
              email={email}
              checkIcon={checkIcon}
              deleteBtnText={deleteBtnText}
            ></SingleDesignTablet>
          </div>
          <div className="desktop_design">
            <SingleDesignDesktop
              changeDesign={changeDesign}
              design={design}
              likes={likes}
              handleDownload={handleDownload}
              vote={vote}
              onClickDeleteDesign={() => setOpenCancelDialog(true)}
              shareUrl={shareUrl}
              userName={userName}
              leftArrow={leftArrow}
              rightArrow={rightArrow}
              userIcon={userIcon}
              calendarIcon={calendarIcon}
              user={user}
              thumbUpIcon={thumbUpIcon}
              downloadIcon={downloadIcon}
              currentIndex={currentDesignIndex}
              designsCount={allDesigns?.length}
              locationData={locationData}
              voteBtnState={voteBtnState}
              onClickVote={onClickVote}
              onChangeEmail={onChangeEmail}
              email={email}
              checkIcon={checkIcon}
              deleteBtnText={deleteBtnText}
            ></SingleDesignDesktop>
          </div>
        </div>
      )}
    </>
  );
};

export default SingleDesign;
